// Полифил для String.prototype.replaceAll
if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function(searchValue: string | RegExp, replaceValue: string | ((substring: string, ...args: any[]) => string)): string {
    if (typeof replaceValue === 'function') {
      return this.replace(searchValue, replaceValue);
    }
    return this.split(searchValue as string).join(replaceValue as string);
  };
}

// Полифил для Promise.allSettled
if (!Promise.allSettled) {
  Promise.allSettled = function<T>(promises: Promise<T>[]): Promise<PromiseSettledResult<T>[]> {
    return Promise.all(
      promises.map(p =>
        p
          .then(value => ({ status: 'fulfilled' as const, value }))
          .catch(reason => ({ status: 'rejected' as const, reason }))
      )
    );
  };
}

// Полифил для Object.entries
if (!Object.entries) {
  Object.entries = function<T>(obj: { [key: string]: T }): [string, T][] {
    const ownProps = Object.keys(obj);
    let i = ownProps.length;
    const resArray = new Array<[string, T]>(i);
    while (i--) {
      const key = ownProps[i];
      resArray[i] = [key, obj[key]];
    }
    return resArray;
  };
}

// Полифил для Object.fromEntries
if (!Object.fromEntries) {
  Object.fromEntries = function<T>(entries: Iterable<readonly [PropertyKey, T]>): { [k: string]: T } {
    return Array.from(entries).reduce((obj, [key, val]) => {
      obj[key as string] = val;
      return obj;
    }, {} as { [k: string]: T });
  };
}

// WebGPU polyfill для старых устройств
if (typeof navigator !== 'undefined' && (navigator as any).gpu === undefined) {
  // Создаем пустой объект navigator.gpu для предотвращения ошибок
  (navigator as any).gpu = {
    requestAdapter: () => Promise.resolve(null),
    getPreferredCanvasFormat: () => 'bgra8unorm'
  };
}

// Простой fallback для WebGPU - не перехватываем requestAdapter
// чтобы избежать проблем с контекстом this 